import React, { useState, useEffect } from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import Header from "../components/header";
import RowView from "../components/rowView";
import {
  getTrending,
  getPopularMovies,
  getNowPlaying,
  getTopRatedMovies,
  discoverMovies,
  GENRES,
} from "../services/tmdb";

function Movie() {
  const [heroItems, setHeroItems] = useState([]);
  const [popular, setPopular] = useState([]);
  const [nowPlaying, setNowPlaying] = useState([]);
  const [topRated, setTopRated] = useState([]);
  const [bollywood, setBollywood] = useState([]);
  const [action, setAction] = useState([]);
  const [comedy, setComedy] = useState([]);

  useEffect(() => {
    async function fetchAll() {
      const [hero, pop, playing, top, bolly, act, com] = await Promise.all([
        getTrending("movie", "week"),
        getPopularMovies(),
        getNowPlaying(),
        getTopRatedMovies(),
        discoverMovies({ with_original_language: "hi" }),
        discoverMovies({ with_genres: GENRES.ACTION }),
        discoverMovies({ with_genres: GENRES.COMEDY }),
      ]);
      setHeroItems(hero?.results || []);
      setPopular(pop?.results || []);
      setNowPlaying(playing?.results || []);
      setTopRated(top?.results || []);
      setBollywood(bolly?.results || []);
      setAction(act?.results || []);
      setComedy(com?.results || []);
    }
    fetchAll();
  }, []);

  return (
    <div>
      <NavBar movies="active" />
      <Header items={heroItems} />
      <RowView heading="🔥 Popular Movies" items={popular} />
      <RowView heading="🎬 Now Playing" items={nowPlaying} />
      <RowView heading="⭐ Top Rated" items={topRated} />
      <RowView heading="🇮🇳 Bollywood" items={bollywood} />
      <RowView heading="💥 Action & Adventure" items={action} />
      <RowView heading="😂 Comedy" items={comedy} />
      <hr style={{ color: "white" }}></hr>
      <Footer />
    </div>
  );
}

export default Movie;
